import { TextExposedField } from "nystem-components";

const MultilinetextExposedField = (props) => <TextExposedField {...props} />;

export default MultilinetextExposedField;
